import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as api from './superfoldersAPI';

const initialState = {
  status: 'idle',
  listOrder: { type: 'latest', order: 'asc' },
  superfolderList: [],
  latestSuperfolderList: [],
  selectedSuperfolder: undefined
};

export const fetchSuperfolders = createAsyncThunk(
  'superfolders/fetchSuperfolders',
  async () => {
    const response = await api.fetchSuperfolders();
    return response.body;
  }
);

export const superfoldersSlice = createSlice({
  name: 'superfolders',
  initialState,
  reducers: {
    selectSuperfolder: (state, action) => {
      state.selectedSuperfolder = action.payload;
    },
    setSelectedSuperfolderTagValue: (state, action) => {
      state.selectedSuperfolder.tags[action.payload.index].value = action.payload.value;
    },
    setListOrder: (state, action) => {
      state.listOrder = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuperfolders.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSuperfolders.fulfilled, (state, action) => {
        let originalFolders = [...action.payload.results];
        let newFolderList = [];
        let newFolders = [];

        if (action.payload?.latest && action.payload.latest.length > 0) {
          let latestFolders = action.payload.latest;

          latestFolders.forEach((folder) => {
            // Find index and content of latest folder
            let pos = originalFolders.findIndex(arr => arr["id"] === folder["id"]);
            let row = originalFolders[pos];
            
            // Remove latest folder from old array and add to a new array
            originalFolders.splice(pos, 1);
            newFolders.push(row);
          })
        }

        originalFolders.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);

        // Add remaining folders to the end of new array
        newFolderList = newFolders.concat(originalFolders);
        
        state.status = 'idle';
        state.superfolderList = action.payload.results;
        state.latestSuperfolderList = newFolderList;
      })
      .addCase(fetchSuperfolders.rejected, (state) => {
        state.status = 'error';
      });
  },
});

export const {
  selectSuperfolder,
  setSelectedSuperfolderTagValue,
  setListOrder
} = superfoldersSlice.actions;

export const selectListOrder = (state) => state.superfolders.listOrder;

export default superfoldersSlice.reducer;
